export default __webpack_public_path__ + "static/media/product-02 (1).7a9a7232.jpg";